// extracted by mini-css-extract-plugin
export var menuIcon = "_ow-0";
export var menuIconInline = "_ow-1";